export default __webpack_public_path__ + "static/media/noleftchatimg.a1297f9b.svg";